<template>
  <b-modal
    id="modulesModal"
    :title="`${isUpdate ? 'Edit' : 'New'} Module`"
    content-class="menu-bg-blue-transparent-modal mod-modal"
    centered
    hide-footer
    @hide="close()"
  >
    <div class="mm-form">

      <!-- Module Name -->
      <div class="mm-field" :class="{ 'mm-field--error': missingFields.module_name }">
        <label class="mm-label">Module Name</label>
        <input
          v-model="editForm.module_name"
          class="mm-input"
          placeholder="Enter module name"
        />
      </div>

      <!-- Description -->
      <div class="mm-field" :class="{ 'mm-field--error': missingFields.module_description }">
        <label class="mm-label">Description</label>
        <textarea
          v-model="editForm.module_description"
          class="mm-input mm-textarea"
          rows="3"
          placeholder="Enter description"
        />
      </div>

      <!-- Module Type -->
      <div class="mm-field" :class="{ 'mm-field--error': missingFields.module_type }">
        <label class="mm-label">Module Type</label>
        <select v-model="editForm.module_type" class="mm-input mm-select">
          <option :value="null" disabled>Select type...</option>
          <option value="tool">Tool</option>
          <option value="feature">Feature</option>
          <option value="admin">Admin</option>
        </select>
      </div>

      <!-- Active / Inactive toggle -->
      <div class="mm-field">
        <label class="mm-label">Status</label>
        <div class="mm-toggle">
          <div
            class="mm-toggle-indicator"
            :style="{
              transform: `translateX(${editForm.isactive ? 0 : 100}%)`,
              background: moduleTypeColor[editForm.module_type] || 'var(--ac-tools)'
            }"
          ></div>
          <button type="button" class="mm-toggle-btn" :class="{ active: editForm.isactive }" @click="editForm.isactive = true">
            Active
          </button>
          <button type="button" class="mm-toggle-btn" :class="{ active: !editForm.isactive }" @click="editForm.isactive = false">
            Inactive
          </button>
        </div>
      </div>

      <div class="mm-actions">
        <b-button variant="primary" size="sm" @click="saveModuleUpdate">Save Changes</b-button>
      </div>

    </div>
  </b-modal>
</template>

<style>
/* ─── Form wrapper ───────────────────────────────────────────── */
.mm-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 4px 0 8px;
}

/* ─── Field group ────────────────────────────────────────────── */
.mm-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.mm-label {
  font-size: 11.5px;
  font-weight: 600;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: #8ab0cc;
  margin: 0;
}

/* ─── Inputs ─────────────────────────────────────────────────── */
.mm-input {
  width: 100%;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 5px;
  padding: 7px 11px;
  font-size: 13px;
  color: #dce8f5;
  outline: none;
  transition: border-color 0.15s, background 0.15s;
  font-family: inherit;
  resize: none;
}
.mm-input::placeholder { color: #5e7080; }
.mm-input:focus {
  border-color: rgba(77, 184, 240, 0.6);
  background: rgba(255, 255, 255, 0.11);
}
.mm-textarea { min-height: 76px; line-height: 1.5; }
.mm-select { cursor: pointer; appearance: none; }
.mm-select option {
  background: #0f2236;
  color: #dce8f5;
}

/* ─── Error state ────────────────────────────────────────────── */
.mm-field--error .mm-label { color: #f07070; }
.mm-field--error .mm-input {
  border-color: rgba(240, 112, 112, 0.55);
  background: rgba(240, 112, 112, 0.07);
}

/* ─── Active / Inactive toggle ───────────────────────────────── */
.mm-toggle {
  position: relative;
  display: flex;
  width: 210px;
  padding: 3px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.1);
  user-select: none;
}
.mm-toggle-indicator {
  position: absolute;
  top: 3px;
  bottom: 3px;
  width: calc(50% - 3px);
  border-radius: 8px;
  transition: transform 0.2s ease;
  z-index: 0;
}
.mm-toggle-btn {
  flex: 1;
  border: none;
  background: transparent;
  padding: 6px 12px;
  border-radius: 8px;
  font-size: 12.5px;
  font-weight: 600;
  cursor: pointer;
  z-index: 1;
  color: #5e7080;
  transition: color 0.2s ease;
  position: relative;
}
.mm-toggle-btn.active { color: #fff; }

/* ─── Actions ────────────────────────────────────────────────── */
.mm-actions {
  display: flex;
  justify-content: flex-end;
  padding-top: 4px;
}

/* ── mod-modal: light-theme overrides ───────────────────────── */
.mod-modal .menu-bg-blue-transparent-modal {
  background: transparent !important;
  color: #063c6d !important;
  text-shadow: none !important;
}
.mod-modal .mm-label { color: rgba(6, 60, 109, 0.7); }
.mod-modal .mm-input {
  background: #f3f5f8 !important;
  border: 1px solid rgba(6, 60, 109, 0.2) !important;
  color: #063c6d !important;
}
.mod-modal .mm-input::placeholder { color: rgba(6, 60, 109, 0.35); }
.mod-modal .mm-input:focus {
  background: #fff !important;
  border-color: #063c6d !important;
  box-shadow: 0 0 0 2px rgba(6, 60, 109, 0.12) !important;
}
.mod-modal .mm-select option { background: #fff; color: #063c6d; }
.mod-modal .mm-toggle {
  background: rgba(6, 60, 109, 0.06) !important;
  border: 1px solid rgba(6, 60, 109, 0.12) !important;
}
.mod-modal .mm-toggle-btn { color: rgba(6, 60, 109, 0.45); }
.mod-modal .mm-toggle-btn.active { color: #fff; }
.mod-modal .mm-toggle-indicator { background: #063c6d !important; }
.mod-modal .mm-field--error .mm-label { color: #c0392b; }
.mod-modal .mm-field--error .mm-input {
  border-color: rgba(192, 57, 43, 0.55) !important;
  background: rgba(192, 57, 43, 0.06) !important;
}
</style>

<script>
import axios from 'axios'
export default {
  name: 'MMP_Modules',
  props: [
    'updateModule',
    'newModule'
  ],
  data() {
    return {
      editForm: {
        id: null,
        module_name: '',
        module_description: '',
        module_type: null,
        isactive: true
      },
      missingFields: {
        module_name: false,
        module_description: false,
        module_type: false
      }
    }
  },
  methods: {
    close() {
      if (!this.isUpdate) {
        this.$emit('removeNewModule', this.editForm)
      }

      this.reset()
    },
    reset() {
      this.editForm = {
        id: null,
        module_name: '',
        module_description: '',
        module_type: null,
        isactive: true
      }
      this.missingFields = {
        module_name: false,
        module_description: false,
        module_type: false
      }
    },
    saveModuleUpdate() {
      const validationFailed = this.validate();
      if (validationFailed) return

      const isUpdate = this.isUpdate
      const endpoint = isUpdate ? 'updateModule' : 'newModule'

      const method = isUpdate ? 'put' : 'post'

      if (sessionStorage.token) {
        axios({
          method: method,
          url: `${process.env.API_LOCATION}/api/users/${endpoint}`,
          headers: { 'x-auth-token': sessionStorage.token },
          data: { module: this.editForm }
        })
          .then(response => {
            let content = response.data
            if (content.errors) {
              console.log(content.errors)
              this.$bvToast.toast(`Server failed to save module changes. Please try again later.`, {
                title: 'Save Status',
                variant: 'danger',
                solid: true
              })
            } else {
              this.$bvToast.toast(`Module saved successfully`, {
                title: 'Save Status',
                variant: 'success',
                solid: true
              })
            }

            this.reset()
            this.$emit('resetModules')
            this.$emit('refreshUserModules')
            this.$bvModal.hide('modulesModal')
          })
          .catch(error => console.log('API error:', error))
      }
    },
    validate() {
      let missing = false;
      this.missingFields = {
        module_name: false,
        module_description: false,
        module_type: false
      }

      if (!this.editForm.module_name) {
        this.missingFields.module_name = true
        missing = true
      }
      if (!this.editForm.module_description) {
        this.missingFields.module_description = true
        missing = true
      }
      if (!this.editForm.module_type) {
        this.missingFields.module_type = true
        missing = true
      }

      setTimeout(() => {
        this.missingFields = {
          module_name: false,
          module_description: false,
          module_type: false
        }
      }, 5000)

      return missing
    }
  },
  computed: {
    isUpdate() {
      return !!this.updateModule
    },
    moduleTypeColor() {
      return {
        tool: 'var(--ac-tools)',
        feature: 'var(--ac-features)',
        admin: 'var(--ac-admin)'
      }
    }
  },
  watch: {
    updateModule: function(newValue) {
      this.editForm = { ...newValue }
    },
    newModule: function(newValue) {
      this.editForm = { ...newValue }
    }
  }
}
</script>
